import { Box, Link, Stack, Text, Tooltip, chakra } from '@chakra-ui/react';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import NextLink from 'next/link';
import * as React from 'react';

import { ClockIcon } from '@/imports/ui/chakra/feather';
import { getFullTimestamp, getTimeAgoShorthand } from '@/utilities';

dayjs.extend(advancedFormat);

export const TimingAndOrigin: React.FC<{
  date: Date | null;
  group: { _id: string; name: string } | null;
  organization: { _id: string; name: string } | null;
  event: { _id: string; name: string } | null;
  isSponsoredPost?: boolean;
  showCommentedHeader?: boolean;
  showDraftedHeader?: boolean;
  disableLinksToGroups?: boolean;
  isScheduledPost?: boolean;
}> = ({
  date,
  group,
  organization,
  event,
  isSponsoredPost,
  showCommentedHeader,
  showDraftedHeader,
  disableLinksToGroups,
  isScheduledPost,
}) => {
  const action = !!isScheduledPost
    ? 'Posting in'
    : !!showDraftedHeader
    ? 'Drafted in '
    : !!showCommentedHeader
    ? 'Commented in'
    : !!isSponsoredPost
    ? 'Sponsored by'
    : 'Posted in';

  const originExists = !!group || !!organization || !!event;

  return (
    <Stack
      direction={{ base: 'column', sm: 'row' }}
      spacing={{ base: 0, sm: 1 }}
      textStyle="compact"
    >
      {!!date && (
        <>
          {isScheduledPost ? (
            <Text as="span">
              <ClockIcon mr="1" mb={0.5} />
              Scheduled for {dayjs(date).format('MMM D, h:mm A z')}
            </Text>
          ) : (
            <Tooltip label={getFullTimestamp(date)} borderRadius="md">
              <Text as="span" fontSize="14px" lineHeight="20px">{dayjs(date).format('MMMM D, YYYY,')}</Text> 
            </Tooltip>
          )}
        </>
      )}
      {originExists && (
        <>
          <Box noOfLines={1}>
            {action}{' '}
            {!!group ? (
              <>
                {disableLinksToGroups ? (
                  group.name
                ) : (
                  <Link
                    as={NextLink}
                    href={`/community/groups/${group._id}/activity`}
                    wordBreak="break-all"
                  >
                    {group.name}
                  </Link>
                )}
              </>
            ) : !!organization ? (
              <Link
                as={NextLink}
                href={`/companies/${organization._id}`}
                wordBreak="break-all"
              >
                {organization.name}
              </Link>
            ) : !!event ? (
              <Link
                as={NextLink}
                href={`/events/${event._id}`}
                wordBreak="break-all"
              >
                {event.name}
              </Link>
            ) : null}
          </Box>
        </>
      )}
    </Stack>
  );
};
